export const dialogStyle = {
    MuiDialog: {
        styleOverrides: {
            paperWidthXs: {
                maxWidth: 444
            },
            paperWidthSm: {
                maxWidth: 600
            },
            paperWidthMd: {
                maxWidth: 900
            },
            paperWidthLg: {
                maxWidth: 1200
            },
            paperWidthXl: {
                maxWidth: 1536
            }
        }
    }
};
